<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><a id="page_v"></a><img alt="image" src="images/pub1.jpg"/></p>
<h1 class="h1"><a id="title"></a>R<span class="small">EMEMBERING THE</span> B<span class="small">ONES</span></h1>
<p class="author"><strong>FRANCES ITANI</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4bd48fda